import * as React from 'react';
import * as styles from './Section.css';
import { clsx } from 'clsx';
import { useSelector } from 'react-redux';
import { selectIsModernDesignAvailable } from '../../../../selectors';

interface IProps {
  children: React.ReactNode;
}

export const SectionContainer = (props: IProps) => {
  const { children } = props;

  const isModernDesignAvailable = useSelector(selectIsModernDesignAvailable);

  const isBordered = !isModernDesignAvailable;

  return <div className={clsx(styles['wrapper'], isBordered && styles['border'])}>{children}</div>;
};
